<template>
    <div class="flex items-center" title="Available Quantity">
        <div v-if="item" class="p-1 rounded-l text-xs" :class="{
          ['bg-green-100 text-green-700'] : item[unit].available >= qty,
          ['bg-red-100 text-red-500'] : item[unit].available < qty
        }">
            {{ item[unit].available }}
        </div>
        <div v-if="item" class="p-1 rounded-r text-xs" :class="{
          ['bg-blue-100 text-blue-600'] : item[unit].total_stock >= qty,
          ['bg-red-200 text-red-600'] : item[unit].total_stock < qty
        }">
            {{ item[unit].total_stock }}
        </div>
    </div>
</template>

<script>
  export default {
    name: 'AvailableQtyBadge',
    props: {
      qty: Number,
      unit: String,
      item: Object
    }
  }
</script>